import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

// Quello che Sicurezza.js fa nel browser senza chiamare il server: copiare i codici di recupero, aprire e chiudere il
// form dei nuovi codici (setNuovi), abilitare "Crea nuovi codici" solo con password o codice, e fermare il cambio
// della password quando le due nuove non coincidono. Per l'SMS (components/sicurezza/Sms.js): aprire e chiudere
// AttivaSms (setScelta) e CambioNumero (setCambio), il pulsante CodiceAlNumero e il busy del form del codice SMS.
export default class extends Controller {
  static targets = ["codice", "nuoviForm", "nuoviApri", "nuoviPassword", "nuoviCodice", "nuoviConferma", "nuova", "conferma",
    "scelta", "attivaSms", "cambio", "cambioApri"]

  // copia di CodiciRecupero: uno per riga
  async copia() {
    try {
      await navigator.clipboard.writeText(this.codiceTargets.map((li) => li.textContent).join("\n"))
      window.toast?.success("Codici copiati")
    } catch {
      window.toast?.error("Copia non riuscita: copiali a mano")
    }
  }

  // setNuovi({ password: "", codice: "" }): il form si apre sempre vuoto
  apriNuovi() {
    this.nuoviPasswordTarget.value = ""
    this.nuoviCodiceTarget.value = ""
    this.aggiornaNuovi()
    this.nuoviApriTarget.hidden = true
    this.nuoviFormTarget.hidden = false
  }

  chiudiNuovi() {
    this.nuoviFormTarget.hidden = true
    this.nuoviApriTarget.hidden = false
  }

  // disabled={!nuovi.password && !nuovi.codice}
  aggiornaNuovi() {
    this.nuoviConfermaTarget.disabled = !this.nuoviPasswordTarget.value && !this.nuoviCodiceTarget.value
  }

  // cambiaPassword: if (pw.nuova !== pw.conferma) return toast.error(...)
  controllaPassword(event) {
    if (this.nuovaTarget.value === this.confermaTarget.value) return
    event.preventDefault()
    window.toast?.error("Le due password nuove non coincidono.")
  }

  // setScelta("sms"): AttivaSms prende il posto della scelta, montato da capo (numero vuoto)
  sceltaSms() {
    this.attivaSmsTarget.querySelectorAll("input:not([type=hidden])").forEach((i) => { i.value = "" })
    this.sceltaTarget.hidden = true
    this.attivaSmsTarget.hidden = false
  }

  annullaSms() {
    this.attivaSmsTarget.hidden = true
    this.sceltaTarget.hidden = false
  }

  // setCambio(true): CambioNumero al posto di "Cambia numero", montato da capo (campi vuoti)
  apriCambio() {
    this.cambioTarget.querySelectorAll("input:not([type=hidden])").forEach((i) => { i.value = "" })
    this.cambioApriTarget.hidden = true
    this.cambioTarget.hidden = false
  }

  annullaCambio() {
    this.cambioTarget.hidden = true
    this.cambioApriTarget.hidden = false
  }

  // CodiceAlNumero: POST /app/sicurezza/sms/codice senza inviare il form che lo contiene; la risposta (Turbo Stream)
  // e' il toast dell'esito o dell'errore. disabled={busy} durante la richiesta.
  async codiceAlNumero(event) {
    const pulsante = event.currentTarget
    pulsante.disabled = true
    const token = document.querySelector('meta[name="csrf-token"]')?.content
    try {
      const risposta = await fetch("/app/sicurezza/sms/codice", {
        method: "POST",
        credentials: "same-origin",
        headers: { Accept: "text/vnd.turbo-stream.html", ...(token ? { "X-CSRF-Token": token } : {}) },
      })
      if (!(risposta.headers.get("Content-Type") || "").includes("turbo-stream")) throw new Error("senza dettaglio")
      Turbo.renderStreamMessage(await risposta.text())
    } catch (_) {
      // formatApiErrorDetail(undefined) dell'originale: rete assente o risposta senza dettaglio
      window.toast?.error("Si è verificato un errore. Riprova.")
    } finally {
      pulsante.disabled = false
    }
  }

  // busy di AttivaSms: durante l'invio (Attiva o "Invia un nuovo codice") entrambi i pulsanti sono disabled
  occupato(event) { this.pulsanti(event).forEach((b) => { b.disabled = true }) }

  libero(event) { this.pulsanti(event).forEach((b) => { b.disabled = false }) }

  pulsanti(event) { return event.target.querySelectorAll("button[type=submit]") }
}
